import React from 'react';
import { Link } from 'react-router-dom';
import Section from '../../components/ui/Section';
import Button from '../../components/ui/Button';
import { motion } from 'framer-motion';

const ProgramCard = ({ title, subtitle, desc, image, to, delay }) => (
  <Link to={to}>
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay }}
      whileHover={{ y: -8 }}
      className="group relative h-[520px] overflow-hidden cursor-pointer rounded-sm"
      style={{ transition: 'box-shadow 0.7s ease' }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 0 40px rgba(212,175,55,0.15), 0 0 80px rgba(212,175,55,0.06)'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}
    >
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 opacity-55" />
      <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/75 to-transparent" />
      {/* Gold frame on hover */}
      <div className="absolute inset-0 border border-transparent group-hover:border-gold/30 transition-all duration-700 rounded-sm" />

      <div className="absolute inset-0 p-10 flex flex-col justify-end">
        <p className="text-gold tracking-widest uppercase text-xs mb-2">{subtitle}</p>
        <h3 className="text-3xl font-serif text-cream mb-4 group-hover:text-gold transition-colors duration-500">{title}</h3>
        <p className="text-cream/65 font-light mb-8 max-h-0 opacity-0 group-hover:max-h-40 group-hover:opacity-100 transition-all duration-700 overflow-hidden leading-relaxed">
          {desc}
        </p>
        <div className="w-10 h-[1px] bg-gold mb-4 group-hover:w-full transition-all duration-700"
          style={{ boxShadow: '0 0 8px rgba(212,175,55,0.6)' }} />
        <span className="text-sm tracking-widest uppercase text-cream/80 flex items-center gap-2">
          Entdecken <span className="group-hover:translate-x-2 transition-transform duration-300">→</span>
        </span>
      </div>
    </motion.div>
  </Link>
);

const ProgramsPreview = () => (
  <Section className="bg-dark">
    <div className="text-center mb-20">
      <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
        className="text-gold tracking-[0.25em] uppercase text-sm mb-4 font-semibold">
        Deine Transformation
      </motion.p>
      <h2 className="text-4xl md:text-5xl font-serif mb-6">
        Wähle Deinen Pfad zur <br />
        <span className="text-gradient-gold italic">Transformation</span>
      </h2>
      <p className="text-cream/55 max-w-2xl mx-auto">Tiefgreifende 6-Monats-Programme für Frauen, die bereit sind, in allen Lebensbereichen aufzusteigen.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <ProgramCard
        title="The Love Code" subtitle="Beziehung & Dualseelen" to="/beziehungsheilung-fuer-frauen"
        desc="Löse emotionale Abhängigkeiten und heile tiefe Wunden. Werde magnetisch für wahre, bedingungslose Liebe."
        image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/0a8dbd1ab6196d088ee699a1d0e6492e.png"
        delay={0.2}
      />
      <ProgramCard
        title="The Business Code" subtitle="Female Leadership" to="/female-leadership-fuer-frauen"
        desc="Heile Dein Impostor-Syndrom. Erschaffe ein Business aus Deiner weiblichen Intuition heraus."
        image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/c8e44d59a4e812fc499ebd3f1cc275f0.png"
        delay={0.4}
      />
    </div>

    <div className="mt-16 text-center">
      <Button variant="outline">Alle Programme ansehen</Button>
    </div>
  </Section>
);

export default ProgramsPreview;